module.exports = __webpack_public_path__ + "static/media/Cash-for-Cars-in-Toowoomba.5be44758.jpg";